module.exports = __webpack_public_path__ + "static/media/ic_chevron-right_2.c4f0fb77.svg";